import React from "react";
import { connect } from "react-redux";

// stylesheet
import classes from "./Participants.scss";

// Design System
import { MultipleUsersOutlined } from "@toddle-edu/ds-icons";

// Utils
import { mapStateToProps, mapActionCreators } from "../../modules/Utils";
import { ParticipantProvider } from "../ParticipantContext";
import classNames from "classnames";

// Components
import EventRow from "../EventRow/EventRow";
import RecipientSelector from "./RecipientSelector";

const ParticipantsV2 = props => {
  const {
    eventModalV2,
    updateEventModalV2,
    isFullScreenMode,
    testId = "",
    reciepentTitleLocaleKey = "calendar:who_should_be_invited_to_this_event",
  } = props;
  const onConfirmSelection = ({
    participantSelections,
    selectedUserTypes,
    selectedListType,
    totalParticipantUserCount,
  }) => {
    const participants = {
      [selectedListType]: participantSelections[selectedListType],
    };
    const sharedWith = selectedUserTypes;
    const entityType = selectedListType;
    updateEventModalV2({
      participants,
      sharedWith,
      entityType,
      totalParticipantUserCount,
    });
  };

  const containerClasses = classNames({
    [classes.container]: true,
    [classes.smallModalContainer]: !isFullScreenMode,
  });

  const getRecipientSelectorContainer = () => {
    return (
      <div className={containerClasses}>
        <ParticipantProvider>
          <RecipientSelector
            onConfirm={onConfirmSelection}
            eventModalV2={eventModalV2}
            updateEventModalV2={updateEventModalV2}
            isFullScreenMode={isFullScreenMode}
            testId={`${testId}-participantsV2-recipientSelector`}
            reciepentTitleLocaleKey={reciepentTitleLocaleKey}
          />
        </ParticipantProvider>
      </div>
    );
  };

  return isFullScreenMode ? (
    getRecipientSelectorContainer()
  ) : (
    <EventRow
      label="common:participants"
      isRequired={true}
      labelClass={classes.participantLabel}
      className={classes.participantRowContainer}
      icon={<MultipleUsersOutlined variant="subtle" />}
      renderComponent={getRecipientSelectorContainer}
    />
  );
};

export default connect(mapStateToProps, mapActionCreators)(ParticipantsV2);
